module.exports = __webpack_public_path__ + "266c2b30a82fe3ae865559b70ace3085.svg";